module.exports = __webpack_public_path__ + "static/media/pic3.98782b58.jpg";